
// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import {
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";
// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Breadcrumbs({ icon, title, route, light }) {
  const routes = route.slice(0, -1);

  // 🔹 orgName ko localStorage se nikaalo
  const orgName = localStorage.getItem("orgName");

  return (
    <MDBox mr={{ xs: 0, xl: 2 }}>

      <MDTypography
        fontWeight="bold"
        textTransform="capitalize"
        variant="h6"
        color={light ? "white" : "dark"}
        noWrap
        sx={{
          display: { xs: "none", md: "block" }
        }}
      >
        {title.replace("-", " ")}
      </MDTypography>


      {/* Center: OrgName */}
      {orgName && (
        <MDTypography
          variant="h6"
          fontWeight="bold"
          color={light ? "white" : "dark"}
          textTransform="capitalize"
          sx={{ flexGrow: 1, textAlign: "center", position: "absolute", top: 10, left: 0, right: 0 }}
        >
          {orgName}
        </MDTypography>
      )}
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
